import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Cart } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Cart.Pages.CART}`,
    name: Cart.Pages.CART,
    component: () => import(/* webpackChunkName: "cart" */ './views/Cart.vue'),
    meta: {
      access_roles: RouteRoles[Cart.Pages.CART],
    },
  },
  {
    path: `/${Cart.Pages.DETAIL}/:id`,
    name: Cart.Pages.DETAIL,
    component: () => import(/* webpackChunkName: "cart-detail" */ './views/CartDetail.vue'),
    meta: {
      access_roles: RouteRoles[Cart.Pages.DETAIL],
    },
  },
  {
    path: `/${Cart.Pages.CARTS_HISTORY}`,
    name: Cart.Pages.CARTS_HISTORY,
    component: () => import(/* webpackChunkName: "carts-history" */ './views/CartsHistory.vue'),
    meta: {
      access_roles: RouteRoles[Cart.Pages.DETAIL],
    },
  },
];

export default routes;
